import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const StyledSelector = styled.div`
  display: inline-flex;
  align-items: center;
  align-self: flex-end;
  height: 40px;
  padding: 0 6px;
  background: var(--ds-surface);
  border: 1px solid var(--borderColor);
  border-radius: var(--ds-radius-md);

  span {
    min-width: 56px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
  }
`;

const StyledArrow = styled.button`
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: var(--textColor);
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--ds-row-divider);
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

/**
 * Year selector with previous / next buttons.
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.onChange - Called with a dayjs date of the chosen year.
 * @returns {JSX.Element} - The YearSelector component.
 */
export const YearSelector = ({ onChange }) => {
  const currentYear = dayjs().year();
  const [year, setYear] = useState(currentYear);

  const changeYear = (newYear) => {
    setYear(newYear);
    onChange(newYear === currentYear ? dayjs() : dayjs().year(newYear));
  };

  return (
    <StyledSelector>
      <StyledArrow type="button" onClick={() => changeYear(year - 1)}>
        <LeftOutlined />
      </StyledArrow>
      <span>{year}</span>
      <StyledArrow
        type="button"
        disabled={year >= currentYear}
        onClick={() => changeYear(year + 1)}
      >
        <RightOutlined />
      </StyledArrow>
    </StyledSelector>
  );
};

YearSelector.propTypes = {
  onChange: PropTypes.func.isRequired
};
